import * as yup from "yup";

const validations = yup.object().shape({
  name: yup.string().required("validationMessages.required"),
  price: yup.string().required("validationMessages.required"),
  category: yup.string().required("validationMessages.required"),
  main_category: yup.string().required("validationMessages.required"),
  brand: yup.string().required("validationMessages.required"),
  unit: yup.string().required("validationMessages.required"),
  weight: yup.string().required("validationMessages.required"),
  barcode: yup.string().required("validationMessages.required"),
  card_type: yup.string().required("validationMessages.required"),
  slot_height: yup.string().required("validationMessages.required"),
  slot_width: yup.string().required("validationMessages.required"),
  kdv: yup.string().required("validationMessages.required"),
  contents: yup.string().required("validationMessages.required"),
  informations: yup.string().required("validationMessages.required"),
  usage: yup.string().required("validationMessages.required"),
  nutrition: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().required("validationMessages.required"),
        value: yup.string().required("validationMessages.required"),
        unit: yup.string().required("validationMessages.required"),
      })
    )
    .min(1, "validationMessages.nutrition.required"),
});

export default validations;
